import type { PropsWithChildren } from 'react';
import { forwardRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { GoogleMapsDirectionDropdown } from '@elfsight/widget-modal';
import { getInvertedColor } from '@elfsight/widget-utils';
import useMergedRef from '@react-hook/merged-ref';

interface AddressProps extends PropsWithChildren {
  address?: string;
  locationAddress?: string;
  name?: string;
  locationName?: string;
  withAction?: boolean;
  fontSize?: number;
  color?: string;
  phrases?: {
    open: string;
    getDirection: string;
    copy: string;
  };
}
export const Address = forwardRef<HTMLDivElement, AddressProps>(function (
  {
    address = '',
    locationAddress = '',
    name = '',
    locationName = '',
    children,
    color = '#000',
    withAction = true,
    fontSize = 15,
    phrases,
    ...forwardingProps
  },
  forwardRef
) {
  const [opened, setOpened] = useState<boolean>(false);
  const [anchorElement, setAnchor] = useState<Element | null>(null);

  const openDropDownHandler = () => {
    if (withAction) {
      setOpened(true);
    }
  };

  const mergedRef = useMergedRef(forwardRef, setAnchor);
  const backgroundColor = getInvertedColor(color, ['#fff', '#000']);

  return (
    <StyledAddress
      _color={color}
      _withAction={withAction}
      _fontSize={fontSize}
      {...forwardingProps}
      ref={mergedRef}
    >
      <span onClick={openDropDownHandler}>{address || children}</span>
      <StyledDropdown
        phrases={phrases}
        address={String(locationAddress || address || children)}
        name={locationName || name}
        anchorElement={anchorElement}
        popoutDirection="downward"
        alignment="left"
        open={opened}
        background={backgroundColor}
        fontColor={color}
        displayOver={false}
        onCloseRequest={() => {
          setOpened(false);
        }}
      />
    </StyledAddress>
  );
});

const StyledDropdown = styled(GoogleMapsDirectionDropdown)``;

const StyledAddress = styled.div<{
  _color: string;
  _withAction: boolean;
  _fontSize: number;
}>`
  text-decoration: inherit;
  font-size: ${({ _fontSize }) => _fontSize}px;
  color: ${({ _color }) => _color};
  opacity: 1;
  ${({ _withAction }) =>
    _withAction &&
    css`
      cursor: pointer;
    `};
`;
